import React, { useEffect, useState } from 'react';
import useDisableZoom from '../../hooks/useDisableZoom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  useAnimation?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen = true,
  onClose,
  children,
  useAnimation = false,
}) => {
  useDisableZoom();

  const [isClosed, setClosed] = useState(!isOpen);

  useEffect(() => {
    let timeOut = null;
    if (isOpen === false) {
      if (useAnimation) {
        timeOut = setTimeout(() => {
          setClosed(true);
        }, 500);
      } else {
        setClosed(true);
      }
    } else if (isOpen) {
      setClosed(false);
    }
    return () => {
      timeOut && clearTimeout(timeOut);
    };
  }, [isOpen]);

  if (isClosed) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={(e) => {
          e.stopPropagation();
          onClose?.();
        }}
      ></div>
      <div className="z-10 w-full max-w-2xl p-6">
        <div className="mb-4 flex items-center justify-between">
          {/* <X className="text-inkMuted hover:text-ink" onClick={onClose} /> */}
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
